<template>
  <div>
    <div class="gl_title_bar">
      <div class="gl_tb_left">
        <span class="normaltitle"
              style="font-size: 26px;margin-right:20px">我的消息</span>
        <a href="javascript:;"
           :class="{ gl_pad_btn_active: allread == 0 }"
           class="gl_pad_btn marginLeft10"
           @click="getAllmsglist(0, -1, 1)">全部消息</a>
        <a href="javascript:;"
           :class="{ gl_pad_btn_active: allread == 1 }"
           class="gl_pad_btn marginLeft10"
           @click="getAllmsglist(1, 0, 1)">未读（{{ unreadmsg }}）</a>
      </div>
      <div class="gl_tb_right"
           @click="Allsignrlread()">
        <a href="javascript:;"
           style="font-size: 14px;"
           class="gl_tb_right_more">全部标记为已读</a>
      </div>
    </div>
    <div class="gl_listWrapBar"
         v-show="item.title||item.content"
         v-for="(item, index) in Allmsglist"
         :key="index"
         @click.stop="!item.read && singalread(item)">
      <a href="#"
         class="gl_listItem">
        <div class="gl_listItemTitle fontBold"
             :class="{ gl_ltStyle_dot: item.read == false }">
          {{ item.title }}
        </div>
        <div class="display_between marginTop10">
          <div class="gl_inforshow">
           <div  v-html="item.content"></div>
          </div>
          <div class="gl_inforshow">
            <span class="marginRight20">{{ item.messageTime }}</span>
          </div>
        </div>
      </a>
    </div>

    <!-- 分页器 -->
    <div class="pagination_Wrap"
         v-if="page.total > 0">
      <pagination :total="page.total"
                  :limit="page.pageSize"
                  :page="page.currentPage"
                  @page-change="pageChange"></pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: 'userMymsg',
  data () {
    return {
      apiData: [],
      allread: 0,
      // 用户id
      AuthorId: '37',
      // 消息列表
      Allmsglist: [],
      page: {
        total: 0,
        pageSize: 5,
        currentPage: 1,
      },
      alltype: '',
      // 未读数量
      unreadmsg: '',
    };
  },
  created () {
    if (localStorage.getItem('ResData')) {
      // 用户id
      this.AuthorId = JSON.parse(localStorage.getItem('ResData')).id;
    }
    this.getAllmsglist(0, -1, 1);
    this.getUnreadmsg();
    this.getData();
  },
  methods: {
    getData () {
      var that = this;
      fetch('/data.json')
        .then(res => {
          return res.json();
        })
        .then(data => {
          that.apiData = data.userMymsg.data;
        })
    },
    // 获取未读消息数量
    getUnreadmsg () {
      this.httphelper
        .post('/api/MessageApi/GetNewMessageCount', {
          userId: this.AuthorId,
        })
        .then(res => {
          this.unreadmsg = res.data.data;
        });
    },
    // 获取消息列表
    getAllmsglist (index, type, val) {
      this.allread = index;
      this.alltype = type;
      this.page.currentPage = val;
      this.httphelper
        .post('/api/MessageApi/GetNewMessagePageList', {
          userId: this.AuthorId,
          mType: type,
          page: val,
          limit: this.page.pageSize,
        })
        .then(res => {
          this.Allmsglist = res.data.data;
          this.page.total = res.data.totalcount;
        });
    },
    // 删除消息
    delreadmsg (id) {
      this.$confirm('消息删除后不可找回，是否确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.httphelper
          .post('/api/MessageApi/DelMessageInfo', {
            userId: this.AuthorId,
            mid: String(id),
            mtype: 1,
          })
          .then(res => {
            if (res.data.code == 200) {
              this.$message({
                message: '删除消息成功',
                type: 'success',
              });
              this.getUnreadmsg();
              this.getAllmsglist(0, -1, 1);
            } else {
              this.$message({
                message: '删除消息失败',
                type: 'warning',
              });
            }
          });
      });
    },
    /**点击分页事件 */
    pageChange (page) {
      if (document.body.scrollTop) {
        document.body.scrollTop = 0;
      } else {
        document.documentElement.scrollTop = 0;
      }
      if (page == this.page.currentPage) {
        return;
      }
      this.page.currentPage = page;
      // this.pageIndex = page;
      this.getAllmsglist(this.allread, this.alltype, page);
    },
    // 更新全部消息状态
    Allsignrlread () {
      this.httphelper
        .post('/api/MessageApi/UptNewMessageInfo', {
          mId: 0,
          userId: this.AuthorId,
          upType: 2,
        })
        .then(res => {
          if (res.data.code == 200) {
            this.getUnreadmsg();
            this.getAllmsglist(0, -1, 1);
          }
        });
    },
    // 点击单个消息标记已读
    singalread (item) {
      this.httphelper
        .post('/api/MessageApi/UptNewMessageInfo', {
          mId: item.mid,
          userId: this.AuthorId,
          upType: 1,
        })
        .then(res => {
          if (res.data.code == 200) {
            this.getUnreadmsg();
            this.getAllmsglist(0, -1, 1);
          }
        });
    },
  },
};
</script>

<style scoped>
.gl_pad_btn {
    line-height: 31px !important;
    text-align: center;
}
.gl_inforshow {
    font-size: 14px;
}
</style>
